import { useState } from 'react';
import AnimatedLogo from './AnimatedLogo';
import { NavLink } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Header.css';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <AnimatedLogo logoSize={{ width: 150 }} />
        </div>

        {/* Hamburger icon for mobile */}
        <div className="hamburger" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>

        {/* Navigation links */}
        <nav className={`nav-links ${isOpen ? 'open' : ''}`}>
          <NavLink to="/" end onClick={() => setIsOpen(false)}>HOME</NavLink>
          <NavLink to="/research" onClick={() => setIsOpen(false)}>RESEARCH</NavLink>
          <NavLink to="/projects" onClick={() => setIsOpen(false)}>PROJECTS</NavLink>
          <NavLink to="/publications" onClick={() => setIsOpen(false)}>PUBLICATIONS</NavLink>
          <NavLink to="/contact" onClick={() => setIsOpen(false)}>CONTACT</NavLink>
        </nav>
      </div>
    </header>
  );
}

export default Header;
